import webApi, { isBrowser } from '../WebApi';
const getStorage = (storageType = 'localStorage') => {
    const storage = webApi[storageType];
    const getItem = (key) => {
        return isBrowser && storage ? storage.getItem(key) : undefined;
    };
    const removeItem = (key) => {
        if (isBrowser && storage)
            storage.removeItem(key);
    };
    const setItem = (key, value) => {
        if (isBrowser && storage)
            storage.setItem(key, value);
    };
    return {
        getItem,
        removeItem,
        setItem,
    };
};
export { getStorage };
//# sourceMappingURL=storage.js.map